import type { TableProps } from 'antd';
import { Table } from 'antd';
import React from 'react';

import styles from './GenericTable.module.scss';
import type { TableEmptyStateConfig } from './TableEmptyState';
import { TableEmptyState } from './TableEmptyState';

export type TableRecord = {
  id: string;
  isSubHeader?: boolean;
};

export type GenericTableProps<T extends TableRecord> = {
  title?: string;
  columns: TableProps<T>['columns'];
  dataSource: T[];
  loading?: boolean;
  emptyState?: TableEmptyStateConfig;
  summary?: () => React.ReactNode;
  rowKey?: TableProps<T>['rowKey'];
};

export const GenericTable = <T extends TableRecord>({
  title,
  columns,
  dataSource,
  emptyState,
  rowKey,
  ...props
}: GenericTableProps<T>) => {
  const hasData = dataSource && dataSource.length > 0;

  return (
    <div className={styles.genericTableContainer}>
      {title && <h3 className={styles.tableTitle}>{title}</h3>}
      {!hasData && emptyState ? (
        <TableEmptyState {...emptyState} />
      ) : (
        <Table
          columns={columns}
          dataSource={dataSource}
          rowKey={
            rowKey ??
            ((record) => record.id?.toString() ?? JSON.stringify(record))
          }
          pagination={false}
          size="middle"
          tableLayout="auto"
          {...props}
          onRow={(record) => ({
            className: record.isSubHeader
              ? styles.subHeaderRow
              : styles.tableRow,
          })}
        />
      )}
    </div>
  );
};
